import { useEffect, useState } from 'react';
import { Grid, MenuItem } from '@mui/material';
import { ExpansionPanel, InputField } from '@/components/common';
import { useCompanyAnnualStore } from '@/store/audit/companyAnnualStore';
import type { CompanyAnnual } from '@/services/accountService/companyAnnualService';

type Props = {
  annualId: number;
  onChange?: (patch: Partial<CompanyAnnual>) => void;
  initialData?: {
    ppe?: number;
    relatedPartyTransactions?: number;
    rentalCommitment?: number;
  } | null;
};

export default function EpOtherDisclosures({ annualId, onChange, initialData }: Props) {
  const store = useCompanyAnnualStore();
  const [local, setLocal] = useState<{ ppe?: number; relatedPartyTransactions?: number; rentalCommitment?: number }>({});

  useEffect(() => {
    if (initialData) {
      setLocal(initialData);
      return;
    }

    let mounted = true;
    (async () => {
      const v = await store.getOtherDisclosuresInfo(annualId);
      if (!mounted) return;
      setLocal(v);
    })();
    return () => { mounted = false; };
  }, [annualId, store, initialData]);

  const emit = (patch: Partial<typeof local>) => {
    const next = { ...local, ...patch };
    setLocal(next);
    onChange?.(patch as Partial<CompanyAnnual>);
  };

  return (
    <ExpansionPanel title="Other Disclosures (其他披露)">
      <Grid container spacing={0.5}>
        <Grid size={6 as any}>
          <InputField select fullWidth variant="outlined" label="PPE (固定資產)" value={local.ppe ?? ''} onChange={(e) => emit({ ppe: Number(e.target.value) as any })}>
            <MenuItem dense value="">Select</MenuItem>
            <MenuItem dense value={0}>No</MenuItem>
            <MenuItem dense value={1}>Yes</MenuItem>
          </InputField>
        </Grid>
        <Grid size={6 as any}>
          <InputField select fullWidth variant="outlined" label="Related Party Transactions (關聯方交易)" value={local.relatedPartyTransactions ?? ''} onChange={(e) => emit({ relatedPartyTransactions: Number(e.target.value) as any })}>
            <MenuItem dense value="">Select</MenuItem>
            <MenuItem dense value={0}>No</MenuItem>
            <MenuItem dense value={1}>Yes</MenuItem>
          </InputField>
        </Grid>
        <Grid size={6 as any}>
          <InputField select fullWidth variant="outlined" label="Rental Commitment (租賃承諾)" value={local.rentalCommitment ?? ''} onChange={(e) => emit({ rentalCommitment: Number(e.target.value) as any })}>
            <MenuItem dense value="">Select</MenuItem>
            <MenuItem dense value={0}>No</MenuItem>
            <MenuItem dense value={1}>Yes</MenuItem>
          </InputField>
        </Grid>
      </Grid>
    </ExpansionPanel>
  );
}
